enum UrlRoutes {
    SINGLE_CAR = 'model',
    CUSTOMER_TYPE = 'tipologia',
}

export default UrlRoutes
